
import { Button } from '../../components/button';

type QuantitySelectorProps = {
  quantity: number;
  onDecrease: () => void;
  onIncrease: () => void;
}

export const QuantitySelector: React.FC<QuantitySelectorProps> = ({ quantity, onDecrease, onIncrease }) => {
  return (
    <div className="flex items-center border border-input rounded-md">
      <Button
        type="button"
        variant="ghost"
        size="icon"
        onClick={onDecrease}
        className="rounded-r-none text-lg font-light text-muted-foreground hover:bg-accent hover:text-accent-foreground"
        aria-label="Decrease quantity"
      >
        -
      </Button>
      <span className="px-4 py-1.5 text-caption1 font-semibold w-12 text-center text-foreground">{quantity}</span>
      <Button
        type="button"
        variant="ghost"
        size="icon"
        onClick={onIncrease}
        className="rounded-l-none text-lg font-light text-muted-foreground hover:bg-accent hover:text-accent-foreground"
        aria-label="Increase quantity"
      >
        +
      </Button>
    </div>
  );
};
